export const setNotes = {
  SET_NOTES(state, payload) {
    state.notes = payload;
  }
};
